import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "beyond-warn"
};
const _hoisted_2 = {
  class: "text-center warning-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  return $options.beyondList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('messages.particle_warning')), 1), _createVNode(_component_el_divider), _createVNode(_component_el_row, {
    class: "warn-table-title"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "text-center warning-text"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('messages.particle_color')), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "text-center normal-text"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('messages.particle_quantity_provided')), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "text-center warning-text"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('messages.particle_quantity_need')), 1)]),
      _: 1
    })]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.beyondList, (o, i) => {
    return _openBlock(), _createBlock(_component_el_row, {
      key: i
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8,
        class: "text-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          class: "particel-img",
          src: o.particelImg,
          fit: "contain"
        }, null, 8, ["src"])]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 8,
        class: "text-center normal-text"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(o.num), 1)]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 8,
        class: "text-center warning-text"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(o.usednum), 1)]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024);
  }), 128))])) : _createCommentVNode("", true);
}